export const faqData = [
  {
    id: 1,
    question: "What is a Car Loan Eligibility Calculator?",
    answer:
      "A Car Loan Eligibility Calculator is a tool that helps you estimate the loan amount you qualify for based on your income, credit score, and other financial details. It simplifies the process of understanding your borrowing capacity.",
  },
  {
    id: 2,
    question: "How does the Car Loan Eligibility Calculator work?",
    answer:
      "MinEMI’s calculator uses the following inputs to determine your eligibility:",
    answerList: [
      {
        info: "Your monthly income.",
      },
      {
        info: "Existing EMIs or financial obligations.",
      },
      {
        info: "Credit score.",
      },
      {
        info: "Desired loan tenure and interest rate. The tool provides an instant estimate of the loan amount you can qualify for.",
      },
    ],
  },
  {
    id: 3,
    question: "Can I use the calculator without impacting my credit score?",
    answer:
      "Yes, MinEMI’s Car Loan Eligibility Calculator works without any impact on your credit score. It uses your provided details to simulate the results instead of conducting a hard inquiry.",
  },
  {
    id: 4,
    question: "What factors affect my car loan eligibility?",
    answer: "Your eligibility depends on:",
    answerList: [
      {
        head: "Income: ",
        info: "A higher income increases your loan eligibility.",
      },
      {
        head: "Credit Score: ",
        info: "A score above 700 ensures better eligibility and interest rates.",
      },
      {
        head: "Existing EMIs: ",
        info: " Lower obligations improve eligibility.",
      },
      {
        head: "Loan Tenure: ",
        info: "Longer tenure increases eligibility but may increase total interest.",
      },
      {
        head: "Age: ",
        info: "Younger applicants may have longer tenure options.",
      },
    ],
  },
  {
    id: 5,
    question: "Can I get a car loan if I have an existing loan?",
    answer:
      "Yes, you can still qualify for a car loan with existing loans, provided your FOIR (Fixed Obligations to Income Ratio) is below 50-60%. MinEMI’s calculator helps you determine this.",
  },
  {
    id: 6,
    question: "How does tenure affect my loan eligibility?",
    answer:
      "Choosing a longer tenure can increase your loan eligibility as it reduces the monthly EMI. However, it also increases the total interest paid over the loan period. Use the calculator to find the right balance.",
  },
  {
    id: 7,
    question: "Can I check eligibility for both new and used car loans?",
    answer:
      "Yes, MinEMI’s calculator allows you to check eligibility for both new and used car loans. Note that interest rates for used car loans are typically higher than for new car loans.",
  },
];
